import React from 'react';

const SvgActions113 = ({ svgRef, title, ...props }) => (
  <svg viewBox="0 0 20 20" ref={svgRef}  {...{ ...{ width: '1em', height: '1em' }, ...props }}>
    <title>{title}</title>
    <path d="M10.88 9.64V4.5a.5.5 0 0 0-.5-.5h-.76a.5.5 0 0 0-.5.5v5.66a.53.53 0 0 0 .15.35l4 4a.51.51 0 0 0 .71 0l.53-.53a.51.51 0 0 0 0-.71zM10 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm0-18C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10A10 10 0 0 0 10 0z" fill="currentColor" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgActions113 svgRef={ref} {...props} />);
export default ForwardRef;
